import React from 'react';
import { useStore } from '../../zustand';
import DefaultTheme from './DefaultTheme';
import LevarDebutTheme from './LevarDebutTheme';
import BillboardDisplay from './BillboardDisplay';
import VariantSwitchDisplay from './VariantSwitchDisplay';
import BillboardVariantSwitchDisplay from './BillboardVariantSwitchDisplay';

export default function ThemeUIController () {
    const { viewer_type } = useStore.getState().settings;
    const { billboards_enabled, variant_switch_enabled, billboard_variant_switch_enabled } = useStore(state => state.scene_controls);
    
    if(viewer_type === "levar_debut") {
        return <LevarDebutTheme />
    } else if(viewer_type === "billboard_display" && billboards_enabled) {
        return <BillboardDisplay />
    } else if(viewer_type === "variant_switch_display" && variant_switch_enabled) { 
        return <VariantSwitchDisplay />
    } else if(viewer_type === "billboard_variant_switch_display" && billboard_variant_switch_enabled) { 
        return <BillboardVariantSwitchDisplay />
    } else {
        return <DefaultTheme />
    }
}